import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/** Skrót klawiszowy (Figma: Kbd 3004:293). */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-xs border border-line bg-canvas px-1',
        'font-sans text-[10px] leading-none font-medium text-fg-muted',
        className,
      )}
    >
      {children}
    </kbd>
  );
}

/** ⌘ na macOS, Ctrl gdzie indziej. */
export function modKeyLabel(): string {
  if (typeof navigator === 'undefined') return 'Ctrl';
  const platform =
    (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ?? navigator.platform;
  return /mac|iphone|ipad/i.test(platform) ? '⌘' : 'Ctrl';
}
